import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
    DialogsState,
    DialogType,
    quotationActionsDialogAction,
    QuotationType,
} from '../../redux/slices/quotationActionsDialogSlice';
import { CartEdge } from '../../models/Cart';

const useQuotationActionsDialog = () => {
    const state: DialogsState = useAppSelector(
        (state) => state.quotationActionsDialog
    );
    const dispatch = useAppDispatch();

    const showDialog = (
        open: boolean,
        dialog: DialogType,
        type: QuotationType,
        products: CartEdge[],
        dialogTitle: string
    ) => {
        dispatch(
            quotationActionsDialogAction.setDialogOpen({
                dialogType: dialog,
                open: open,
                type: type,
                products: products,
                dialogTitle: dialogTitle,
            })
        );
    };

    const closeDialog = () => {
        dispatch(quotationActionsDialogAction.setDialogClose(false));
    };

    return { ...state, showDialog, closeDialog };
};

export default useQuotationActionsDialog;
